(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.arPreviewBound) {
 window.arPreviewBound = true;
 document.addEventListener('click', (event) => {
  const button = event.target.closest('.ar-shotbutton');
  if (!button) return;
  const target = document.getElementById(button.getAttribute('aria-controls'));
  if (!target) return;
  target.hidden = !target.hidden;
  button.setAttribute('aria-expanded', String(!target.hidden));
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if (!window.arMenuBound) {
 window.arMenuBound = true;
 document.addEventListener('click', (event) => {
  const link = event.target.closest('.mobile-draw a[href]');
  if (!link) return;
  const destination = new URL(link.href, location.href);
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
  const drawer = link.closest('.mobile-draw');
  drawer.querySelector('.mfp-close')?.click();
 });
}

  } catch(e) { console.error(e); }
})();
})();
